import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, ConfirmationModal, Icon } from '@components/index';
import { GROUPS } from '@constants/routes';

interface EditGroupHeaderProps {
  groupId: string;
  onSave: () => void;
  isSaveDisabled: boolean;
  isLoading: boolean;
  hasChanges: boolean;
}

const EditGroupHeader = ({
  groupId,
  onSave,
  isSaveDisabled,
  isLoading,
  hasChanges
}: EditGroupHeaderProps) => {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const navigateBack = () => {
    navigate(`${GROUPS.HOME}/${groupId}`);
  };

  const handleCancel = () => {
    if (hasChanges) {
      setShowConfirmationModal(true);
    } else {
      navigateBack();
    }
  };

  const onHandleUnsavedChanges = () => {
    setShowConfirmationModal(false);
    navigateBack();
  };

  const handleSave = () => {
    onSave();
  };

  return (
    <>
      <div className="flex h-22 w-full shrink-0 items-center justify-between bg-white p-6">
        <div className="flex items-center gap-2">
          <Icon
            className="cursor-pointer"
            name="arrow-left"
            onClick={handleCancel}
          />
          <div className="text-2xl font-bold text-cofeeNeutral11">
            Edit group
          </div>
        </div>
        <div className="flex items-center gap-4">
          <Button
            label="Cancel"
            handleClick={handleCancel}
            variant="tertiary"
            className="min-w-30"
          />
          <Button
            label="Save"
            handleClick={handleSave}
            variant="primary"
            className="min-w-30"
            disabled={isSaveDisabled}
            loading={isLoading}
          />
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          isOpen={showConfirmationModal}
          handleCancel={() => setShowConfirmationModal(false)}
          handleConfirm={onHandleUnsavedChanges}
          title="Unsaved Changes"
          message="Are you sure that you want to leave the current page? The changes that you made won't be saved."
          className="w-96"
        />
      )}
    </>
  );
};

export default EditGroupHeader;
